import React, { useEffect, useState } from "react";
import { Spin, Table } from "antd";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import SidebarNav from "../sidebar";
import { Link } from "react-router-dom";
import { addEdd, getUser, updateEdd } from "../../../service/api";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import actions from "../../../redux/user/actions";
import CustomPagination from "../Pagination/pagination";
import FilterPanel from "../commoncomponent/FilterPanel";
import TableToolbar from "../commoncomponent/TableToolbar";
import { useTableSettings } from "../../../hooks/useTableSettings";
import DateRangePicker from "react-bootstrap-daterangepicker";
import Select from "react-select";
import moment from "moment";
import { Box, Fade, Modal } from "@mui/material";
import { sanitizeInput } from "../../../config/validation";
import { triggerDownload } from "../../../config/downloadUtils";

const styleDelete = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 290,
  background: "white",
  borderRadius: "10px",
  boxShadow: 24,
  p: 4,
  outline: "none",
};

const formatDateTime = (val) =>
  val ? moment(val).format("DD/MM/YYYY HH:mm") : "-";

const riskLabel = (score) => {
  if (score === undefined || score === null || score === "") return "-";
  if (score > 7) return "High Risk";
  if (score < 4) return "Low Risk";
  return "Medium Risk";
};

const ALL_COLUMNS = [
  {
    key: "user",
    title: "User",
    defaultVisible: true,
    render: (r) => `${r?.firstName ?? ""} ${r?.lastName ?? ""}`.trim() || "-",
  },
  {
    key: "email",
    title: "Email",
    defaultVisible: true,
    render: (r) => r?.email || "-",
  },
  {
    key: "phoneNumber",
    title: "Phone Number",
    defaultVisible: true,
    render: (r) => r?.phoneNumber || "-",
  },
  {
    key: "riskAssessment",
    title: "Risk Assessment",
    defaultVisible: true,
    render: (r) => riskLabel(r?.riskAssessment?.score),
  },
  {
    key: "riskScore",
    title: "Risk Score",
    defaultVisible: false,
    render: (r) =>
      r?.riskAssessment?.score !== undefined &&
      r?.riskAssessment?.score !== null
        ? r.riskAssessment.score
        : "-",
  },
  {
    key: "kycStatus",
    title: "KYC Status",
    defaultVisible: false,
    render: (r) => r?.kycStatus || "-",
  },
  {
    key: "eddStatus",
    title: "EDD Status",
    defaultVisible: false,
    render: (r) => r?.eddStatus || "-",
  },
  {
    key: "createdAt",
    title: "Created At",
    defaultVisible: false,
    render: (r) => formatDateTime(r?.createdAt),
  },
];

const eddStatusOptions = [
  { label: "Pending", value: "PENDING" },
  { label: "Approved", value: "APPROVED" },
  { label: "Rejected", value: "REJECTED" },
];

const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: "38px",
    height: "40px",
    width: "200px",
    minWidth: "120px",
    borderRadius: "4px",
    border: "1px solid #ced4da",
    fontSize: "14px",
    padding: "0px 4px",
    backgroundColor: "#fff",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "4px",
  }),
  indicatorSeparator: () => ({ display: "none" }),
};

const Edd = () => {
  const [userList, setUserlist] = useState([]);
  const [loading, setLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const dispatch = useDispatch();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [eddStatus, setEddStatus] = useState();
  const [imageModalVisible, setImageModalVisible] = useState(false);
  const [modalImages, setModalImages] = useState([]);
  const [modalTitle, setModalTitle] = useState("");

  const {
    pageSize,
    setPageSize,
    pageSizeOptions,
    visibleColumnKeys,
    toggleColumn,
    resetColumns,
    dynamicColumns,
  } = useTableSettings({
    storageKey: "edd-list",
    allColumns: ALL_COLUMNS,
  });

  const handleViewEddDocs = (row) => {
    const docs = row?.eddDocs;
    if (docs && typeof docs === "object") {
      let files = [];

      Object.entries(docs).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((url) => {
            files.push(classifyFile(url, key));
          });
        } else if (typeof value === "string") {
          files.push(classifyFile(value, key));
        }
      });

      if (files.length > 0) {
        setModalImages(files);
        setModalTitle(`${row?.firstName} ${row?.lastName} - EDD Documents`);
        setImageModalVisible(true);
      } else {
        toast.info("No EDD documents uploaded.", { toastId: 'edd-no-documents' });
      }
    } else {
      toast.info("No EDD documents uploaded.");
    }
  };

  const classifyFile = (url, label) => {
    if (url.match(/\.(jpg|jpeg|png|gif)$/i)) {
      return { url, type: "image", label };
    } else if (url.match(/\.(mp4|webm|ogg)$/i)) {
      return { url, type: "video", label };
    } else {
      return { url, type: "other", label };
    }
  };

  const getUserList = () => {
    let body = {
      page: page,
      sizePerPage: pageSize,
      pagination: true,
      edd: true,
    };
    if (searchTerm) {
      body.search = searchTerm;
    }
    if (eddStatus) {
      body.eddStatus = eddStatus?.value;
    }
    if (startDate) {
      body.startDate = startDate;
    }
    if (endDate) {
      body.endDate = endDate;
    }

    setLoading(true);
    getUser(body)
      .then((res) => {
        if (res?.status) {
          setUserlist(res?.data);
          dispatch(actions.setUserList(res?.data?.result));
        }
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDownload = (format) => {
    const body = { pagination: false, edd: true };
    if (searchTerm) body.search = searchTerm;
    if (eddStatus) body.eddStatus = eddStatus?.value;
    if (startDate) body.startDate = startDate;
    if (endDate) body.endDate = endDate;
    setDownloadLoading(true);
    getUser(body)
      .then((res) => {
        const result = res?.data?.result ?? [];
        if (!result.length) { toast.warning("Nothing to download", { toastId: 'nothing-to-download' }); return; }
        const cols = ALL_COLUMNS.filter((c) => visibleColumnKeys.includes(c.key));
        triggerDownload(format, result, cols, "edd-users");
      })
      .finally(() => setDownloadLoading(false));
  };

  useEffect(() => {
    getUserList();
  }, [page, pageSize, startDate, endDate, searchTerm, eddStatus]);

  // Reset to page 1 whenever filters or page size change.
  useEffect(() => {
    setPage(1);
  }, [pageSize, startDate, endDate, searchTerm, eddStatus]);

  const handleDateRangeChange = (event, picker) => {
    setStartDate(picker.startDate.format("YYYY-MM-DD"));
    setEndDate(picker.endDate.format("YYYY-MM-DD"));
  };

  const handleEdd = (id, status) => {
    if (loading) {
      return;
    }
    setLoading(true);
    let body = {
      edd: status === "NO-EDD" ? false : true,
      eddStatus: status,
    };

    updateEdd(id, body)
      ?.then((res) => {
        if (res?.status) {
          getUserList();
        }
      })
      ?.catch((e) => {
        toast.error(e?.response?.data?.message, { toastId: 'edd-fetch-error' });
      })
      ?.finally(() => {
        setLoading(false);
      });
  };

  const actionColumn = {
    key: "__action",
    title: "Action",
    className: "text-end",
    render: (_, row) => (
      <div className="text-end">
        {row?.eddDocs && (
          <a
            className="me-1 btn btn-sm bg-info-light"
            onClick={() => handleViewEddDocs(row)}
            style={{ cursor: "pointer" }}
          >
            View
          </a>
        )}

        <a
          className="me-1 btn btn-sm bg-primary-light "
          onClick={() => {
            handleEdd(row?._id, "NO-EDD");
          }}
        >
          Approve
        </a>

        <a
          onClick={() => {
            handleEdd(row?._id, "REJECTED");
          }}
          className="me-1 btn btn-sm bg-danger-light"
        >
          <i className="fe fe-trash"></i> Reject
        </a>
      </div>
    ),
  };

  const columns2 = [...dynamicColumns, actionColumn];

  return (
    <>
      <SidebarNav />
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-7 col-aut0">
                <h3 className="page-title">User</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admin">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">User</li>
                </ul>
              </div>
              <div className="col-sm-5 col"></div>
            </div>
          </div>

          {/* /Page Header */}
          <div className="list-layout">
            <div className="list-layout__main">
              <div className="card">
                <div className="card-body">
                  <TableToolbar
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    pageSizeOptions={pageSizeOptions}
                    total={userList?.total}
                    page={page}
                    visibleColumnKeys={visibleColumnKeys}
                    allColumns={ALL_COLUMNS}
                    toggleColumn={toggleColumn}
                    resetColumns={resetColumns}
                    onDownload={handleDownload}
                    downloadLoading={downloadLoading}
                  />
                  <div className="table-responsive">
                    {loading ? (
                      <div className="his-spin">
                        <Spin
                          size="large"
                          style={{ position: "relative", top: "35%" }}
                        />
                      </div>
                    ) : (
                      <Table
                        pagination={false}
                        style={{ overflowX: "auto" }}
                        columns={columns2}
                        dataSource={userList ? userList?.result : []}
                        rowKey={(record) => record._id || record.id}
                      />
                    )}
                    {userList && userList?.total > pageSize && (
                      <CustomPagination
                        key={`pg-${pageSize}`}
                        totalTabs={userList?.total}
                        tabsPerPage={pageSize}
                        handleChange={setPage}
                        className={`${
                          loading ? "display-hide" : "display-flex"
                        }`}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="list-layout__filters">
              <FilterPanel
                count={userList?.total}
                onClear={() => {
                  setSearchTerm("");
                  setEddStatus(null);
                  setStartDate();
                  setEndDate();
                }}
              >
                <FilterPanel.Field label="Search">
                  <input
                    type="text"
                    placeholder="Name or email"
                    value={searchTerm}
                    onChange={(e) =>
                      setSearchTerm(sanitizeInput(e.target.value))
                    }
                  />
                </FilterPanel.Field>
                <FilterPanel.Field label="EDD Status">
                  <Select
                    options={eddStatusOptions}
                    value={eddStatus || null}
                    onChange={(option) => setEddStatus(option)}
                    styles={customStyles}
                    placeholder="Any"
                    isClearable
                  />
                </FilterPanel.Field>
                <FilterPanel.Field label="Date Range">
                  <DateRangePicker
                    onApply={handleDateRangeChange}
                    isClearable={true}
                  >
                    <input
                      type="text"
                      placeholder="Select date range"
                      readOnly
                    />
                  </DateRangePicker>
                </FilterPanel.Field>
              </FilterPanel>
            </div>
          </div>
        </div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={imageModalVisible}
          onClose={() => setImageModalVisible(false)}
          closeAfterTransition
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: 2,
          }}
        >
          <Fade in={imageModalVisible}>
            <Box
              sx={{
                width: {
                  xs: "95vw",
                  sm: 400,
                  md: 600,
                  lg: 700,
                },
                maxWidth: "98vw",
                bgcolor: "background.paper",
                borderRadius: 2,
                boxShadow: 24,
                p: 2,
                outline: "none",
                maxHeight: "90vh",
                overflowY: "auto",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 16,
                }}
              >
                <div style={{ fontWeight: 600, fontSize: 18 }}>
                  {modalTitle || "EDD Documents"}
                </div>
                <button
                  onClick={() => setImageModalVisible(false)}
                  style={{
                    background: "none",
                    border: "none",
                    fontSize: 24,
                    cursor: "pointer",
                    lineHeight: 1,
                    color: "#888",
                    padding: 0,
                  }}
                  aria-label="Close"
                >
                  &times;
                </button>
              </div>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 16,
                  justifyContent: "center",
                }}
              >
                {modalImages && modalImages.length > 0 ? (
                  modalImages.map((file, idx) => (
                    <div key={idx} style={{ marginBottom: "16px" }}>
                      {file.label !== "date" && <strong>{file.label}</strong>}
                      {file.type === "image" ? (
                        <img
                          src={file.url}
                          alt={file.label}
                          draggable="false"
                          onContextMenu={(e) => e.preventDefault()}
                          style={{ width: 200 }}
                        />
                      ) : file.type === "video" ? (
                        <video src={file.url} controls width={300} />
                      ) : file.label === "date" ? (
                        <p></p>
                      ) : (
                        <a
                          href={file.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            display: "inline-block",
                            color: "blue",
                            textDecoration: "underline",
                            marginTop: "8px",
                          }}
                        >
                          View Document
                        </a>
                      )}
                    </div>
                  ))
                ) : (
                  <span>No images found.</span>
                )}
              </div>
            </Box>
          </Fade>
        </Modal>
      </div>
    </>
  );
};

export default Edd;
